// 启航会员
const beginnerVipList = [
    [{
        value: '权益名称'
    }, {
        value: '启航会员',
        src: 'https://lvlin-base.bj.bcebos.com/fe-saas/page/account/qihangs.png'
    }, {
        value: '精英会员'
    }, {
        value: '尊享会员'
    }],
    [{
        value: '百度搜索首位名片卡'
    }, {
        value: '启航会员专属样式，一年期有效'
    }, {
        value: '精英会员专属样式，一年期有效'
    }, {
        value: '尊享会员专属样式，一年期有效'
    }],
    [{
        value: '百度搜索首位推荐卡'
    }, {
        value: ''
    }, {
        value: '会员有效期内优先展示'
    }, {
        value: '会员有效期内优先展示'
    }],
    [{
        value: '严选律师标签'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }],
    [{
        value: '擅长领域标签'
    }, {
        value: '3个/一年期有效，不可加购更多领域标签'
    }, {
        value: '3个/一年期有效，会员可加购更多专属领域标签'
    }, {
        value: '3个/一年期有效，会员可加购更多专属领域标签'
    }],
    [{
        value: '付费电话咨询'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }],
    [{
        value: '百度律临全站推荐'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }],
    // [{
    //     value: '免费在线咨询'
    // }, {
    //     value: '1小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '3小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '6小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }],
    [{
        value: '即时线索抢单'
    }, {
        value: ''
    }, {
        value: '36条/年，按月领取'
    }, {
        value: '60条/年，按月领取'
    }],
    [{
        value: '公开咨询抢答'
    }, {
        value: '会员有效期内无限畅领，可见线索限量20%'
    }, {
        value: '会员有效期内无限畅领，可见线索限量50%'
    }, {
        value: '会员有效期内无限畅领，可见线索限量70%'
    }],
    [{
        value: '法律文章免费认领'
    }, {
        value: ''
    }, {
        value: '80条/按年领取'
    }, {
        value: '120条/按年领取'
    }],
    [{
        value: '问答内容页律师推荐卡'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }]
];

const beginnerColorList = [
    [
        '#F8FBFF',
        'linear-gradient(138.21deg, #EDF6FF 12.93%, #EAF2FF 88.17%)',
        'linear-gradient(138.21deg, #EAEDFF 12.93%, #E9F1FF 88.17%)',
        'linear-gradient(134.06deg, rgba(255, 234, 219, 0.7) -8.19%, rgba(255, 242, 216, 0.7) 100%)'
    ],
    [
        '#FFFFFF',
        '#FBFCFF',
        '#F6FAFF',
        '#FFFCF6'
    ]
];

const beginnerFontList = [{
    color: '#1E1F24',
    fontSize: '16px',
    fontWeight: '500'
}, {
    color: '#071B40',
    fontSize: '14px',
    fontWeight: '500',
    isSelect: true
}, {
    color: '#071B40',
    fontSize: '14px'
}, {
    color: '#79390A',
    fontSize: '14px'
}];

// 精英会员
const eliteVipList = [
    [{
        value: '权益名称'
    }, {
        value: '启航会员'
    }, {
        value: '精英会员',
        src: 'https://lvlin-base.bj.bcebos.com/fe-saas/page/account/jingying.png'
    }, {
        value: '尊享会员'
    }],
    [{
        value: '百度搜索首位名片卡'
    }, {
        value: '启航会员专属样式，一年期有效'
    }, {
        value: '精英会员专属样式，一年期有效'
    }, {
        value: '尊享会员专属样式，一年期有效'
    }],
    [{
        value: '百度搜索首位推荐卡'
    }, {
        value: ''
    }, {
        value: '会员有效期内优先展示'
    }, {
        value: '会员有效期内优先展示'
    }],
    [{
        value: '严选律师标签'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }],
    [{
        value: '擅长领域标签'
    }, {
        value: '3个/一年期有效，不可加购更多领域标签'
    }, {
        value: '3个/一年期有效，会员可加购更多专属领域标签'
    }, {
        value: '3个/一年期有效，会员可加购更多专属领域标签'
    }],
    [{
        value: '付费电话咨询'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }],
    [{
        value: '百度律临全站推荐'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }],
    // [{
    //     value: '免费在线咨询'
    // }, {
    //     value: '1小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '3小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '6小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }],
    [{
        value: '即时线索抢单'
    }, {
        value: ''
    }, {
        value: '36条/年，按月领取'
    }, {
        value: '60条/年，按月领取'
    }],
    [{
        value: '公开咨询抢答'
    }, {
        value: '会员有效期内无限畅领，可见线索限量20%'
    }, {
        value: '会员有效期内无限畅领，可见线索限量50%'
    }, {
        value: '会员有效期内无限畅领，可见线索限量70%'
    }],
    [{
        value: '法律文章免费认领'
    }, {
        value: ''
    }, {
        value: '80条/按年领取'
    }, {
        value: '120条/按年领取'
    }],
    [{
        value: '问答内容页律师推荐卡'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }]
];

const eliteColorList = [
    [
        '#F8FBFF',
        'linear-gradient(138.21deg, rgba(224, 240, 255, 0.4) 12.93%, rgba(220, 233, 255, 0.4) 88.17%)',
        'linear-gradient(138.21deg, #EAEBFD 12.93%, #E8EFFD 88.17%)',
        'linear-gradient(134.06deg, rgba(255, 234, 219, 0.7) -8.19%, rgba(255, 242, 216, 0.7) 100%)'
    ],
    [
        '#FFFFFF',
        '#FBFCFF',
        '#F6FAFF',
        '#FFFCF6'
    ]
];

const eliteFontList = [{
    color: '#1E1F24',
    fontSize: '16px',
    fontWeight: '500'
}, {
    color: '#071B40',
    fontSize: '14px'
}, {
    color: '#071B40',
    fontSize: '14px',
    fontWeight: '500',
    isSelect: true
}, {
    color: '#79390A',
    fontSize: '14px'
}];

// 尊享会员
const vipList = [
    [{
        value: '权益名称'
    }, {
        value: '启航会员'
    }, {
        value: '精英会员'
    }, {
        value: '尊享会员',
        src: 'https://lvlin-base.bj.bcebos.com/fe-saas/page/account/zunxiangs.png'
    }],
    [{
        value: '百度搜索首位名片卡'
    }, {
        value: '启航会员专属样式，一年期有效'
    }, {
        value: '精英会员专属样式，一年期有效'
    }, {
        value: '尊享会员专属样式，一年期有效'
    }],
    [{
        value: '百度搜索首位推荐卡'
    }, {
        value: ''
    }, {
        value: '会员有效期内优先展示'
    }, {
        value: '会员有效期内优先展示'
    }],
    [{
        value: '严选律师标签'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }],
    [{
        value: '擅长领域标签'
    }, {
        value: '3个/一年期有效，不可加购更多领域标签'
    }, {
        value: '3个/一年期有效，会员可加购更多专属领域标签'
    }, {
        value: '3个/一年期有效，会员可加购更多专属领域标签'
    }],
    [{
        value: '付费电话咨询'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }],
    [{
        value: '百度律临全站推荐'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }],
    // [{
    //     value: '免费在线咨询'
    // }, {
    //     value: '1小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '3小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '6小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }],
    [{
        value: '即时线索抢单'
    }, {
        value: ''
    }, {
        value: '36条/年，按月领取'
    }, {
        value: '60条/年，按月领取'
    }],
    [{
        value: '公开咨询抢答'
    }, {
        value: '会员有效期内无限畅领，可见线索限量20%'
    }, {
        value: '会员有效期内无限畅领，可见线索限量50%'
    }, {
        value: '会员有效期内无限畅领，可见线索限量70%'
    }],
    [{
        value: '法律文章免费认领'
    }, {
        value: ''
    }, {
        value: '80条/按年领取'
    }, {
        value: '120条/按年领取'
    }],
    [{
        value: '问答内容页律师推荐卡'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }]
];

const vipColorList = [
    [
        '#F8FBFF',
        'linear-gradient(138.21deg, rgba(224, 240, 255, 0.4) 12.93%, rgba(220, 233, 255, 0.4) 88.17%)',
        'linear-gradient(138.21deg, rgba(224, 226, 255, 0.4) 12.93%, rgba(220, 233, 255, 0.4) 88.17%)',
        'linear-gradient(134.06deg, rgba(255, 234, 219, 1) -8.19%, rgba(255, 242, 216, 1) 100%)'
    ],
    [
        '#FFFFFF',
        '#FBFCFF',
        '#F6FAFF',
        '#FFFCF6'
    ]
];

const vipFontList = [{
    color: '#1E1F24',
    fontSize: '16px',
    fontWeight: '500'
}, {
    color: '#071B40',
    fontSize: '14px'
}, {
    color: '#071B40',
    fontSize: '14px'
}, {
    color: '#79390A',
    fontSize: '14px',
    fontWeight: '500',
    isSelect: true
}];

// 体验会员
const freeVipList = [
    [{
        value: '权益名称'
    }, {
        value: '启航会员'
    }, {
        value: '精英会员'
    }, {
        value: '尊享会员'
    }, {
        value: '体验会员',
        src: 'https://lvlin-base.bj.bcebos.com/fe-saas/page/account/qihangs.png'
    }],
    [{
        value: '百度搜索首位名片卡'
    }, {
        value: '启航会员专属样式，一年期有效'
    }, {
        value: '精英会员专属样式，一年期有效'
    }, {
        value: '尊享会员专属样式，一年期有效'
    }, {
        value: '体验期内展示'
    }],
    [{
        value: '百度搜索首位推荐卡'
    }, {
        value: ''
    }, {
        value: '会员有效期内优先展示'
    }, {
        value: '会员有效期内优先展示'
    }, {
        value: '体验期内展示'
    }],
    [{
        value: '严选律师标签'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }],
    [{
        value: '擅长领域标签'
    }, {
        value: '3个/一年期有效，不可加购更多领域标签'
    }, {
        value: '3个/一年期有效，会员可加购更多专属领域标签'
    }, {
        value: '3个/一年期有效，会员可加购更多专属领域标签'
    }, {
        value: '3个/体验结束后自动取消1个标签'
    }],
    [{
        value: '付费电话咨询'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: ''
    }],
    [{
        value: '百度律临全站推荐'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '体验期内曝光'
    }],
    // [{
    //     value: '免费在线咨询'
    // }, {
    //     value: '1小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '3小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '6小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '体验期内曝光'
    // }],
    [{
        value: '即时线索抢单'
    }, {
        value: ''
    }, {
        value: '36条/年，按月领取'
    }, {
        value: '60条/年，按月领取'
    }, {
        value: '5条/体验期内可用'
    }],
    [{
        value: '公开咨询抢答'
    }, {
        value: '会员有效期内无限畅领，可见线索限量20%'
    }, {
        value: '会员有效期内无限畅领，可见线索限量50%'
    }, {
        value: '会员有效期内无限畅领，可见线索限量70%'
    }, {
        value: '日均5次/体验期内可用'
    }],
    [{
        value: '法律文章免费认领'
    }, {
        value: ''
    }, {
        value: '80条/按年领取'
    }, {
        value: '120条/按年领取'
    }, {
        value: '120条/体验期内可用，体验结束后内容自动改为默认律师'
    }],
    [{
        value: '问答内容页律师推荐卡'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '体验期内展示'
    }]
];

const freeColorList = [
    [
        '#F8FBFF',
        'linear-gradient(138.21deg, rgba(224, 240, 255, 0.4) 12.93%, rgba(220, 233, 255, 0.4) 88.17%)',
        'linear-gradient(138.21deg, rgba(224, 226, 255, 0.4) 12.93%, rgba(220, 233, 255, 0.4) 88.17%)',
        'linear-gradient(134.06deg, rgba(255, 234, 219, 0.4) -8.19%, rgba(255, 242, 216, 0.4) 100%)',
        'linear-gradient(134.06deg, rgba(255, 234, 219, 1) -8.19%, rgba(255, 242, 216, 1) 100%)'
    ],
    [
        '#FFFFFF',
        '#FBFCFF',
        '#F6FAFF',
        '#FFFCF6',
        '#FFFCF6'
    ]
];

const freeFontList = [{
    color: '#1E1F24',
    fontSize: '16px',
    fontWeight: '500'
}, {
    color: '#071B40',
    fontSize: '14px'
}, {
    color: '#071B40',
    fontSize: '14px'
}, {
    color: '#79390A',
    fontSize: '14px'
}, {
    color: '#79390A',
    fontSize: '14px',
    fontWeight: '500',
    isSelect: true
}];

// 过期会员
const outVipList = [
    [{
        value: '权益名称'
    }, {
        value: '启航会员'
    }, {
        value: '精英会员'
    }, {
        value: '尊享会员'
    }, {
        value: '入驻律师'
    }],
    [{
        value: '百度搜索首位名片卡'
    }, {
        value: '启航会员专属样式，一年期有效'
    }, {
        value: '精英会员专属样式，一年期有效'
    }, {
        value: '尊享会员专属样式，一年期有效'
    }, {
        value: ''
    }],
    [{
        value: '百度搜索首位推荐卡'
    }, {
        value: ''
    }, {
        value: '会员有效期内优先展示'
    }, {
        value: '会员有效期内优先展示'
    }, {
        value: ''
    }],
    [{
        value: '严选律师标签'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: ''
    }],
    [{
        value: '擅长领域标签'
    }, {
        value: '3个/一年期有效，不可加购更多领域标签'
    }, {
        value: '3个/一年期有效，会员可加购更多专属领域标签'
    }, {
        value: '3个/一年期有效，会员可加购更多专属领域标签'
    }, {
        value: '2个'
    }],
    [{
        value: '付费电话咨询'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: ''
    }],
    [{
        value: '百度律临全站推荐'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: ''
    }],
    // [{
    //     value: '免费在线咨询'
    // }, {
    //     value: '1小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '3小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '6小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: ''
    // }],
    [{
        value: '即时线索抢单'
    }, {
        value: ''
    }, {
        value: '36条/年，按月领取'
    }, {
        value: '60条/年，按月领取'
    }, {
        value: ''
    }],
    [{
        value: '公开咨询抢答'
    }, {
        value: '会员有效期内无限畅领，可见线索限量20%'
    }, {
        value: '会员有效期内无限畅领，可见线索限量50%'
    }, {
        value: '会员有效期内无限畅领，可见线索限量70%'
    }, {
        value: ''
    }],
    [{
        value: '法律文章免费认领'
    }, {
        value: ''
    }, {
        value: '80条/按年领取'
    }, {
        value: '120条/按年领取'
    }, {
        value: ''
    }],
    [{
        value: '问答内容页律师推荐卡'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: ''
    }],
    [{
        value: '法规检索工具'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }],
    [{
        value: '案例检索工具'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }],
    [{
        value: 'AI合同助手'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }],
    [{
        value: 'AI诉保助手'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }]
];

const outColorList = [
    [
        '#F8FBFF',
        'linear-gradient(138.21deg, rgba(224, 240, 255, 0.4) 12.93%, rgba(220, 233, 255, 0.4) 88.17%)',
        'linear-gradient(138.21deg, rgba(224, 226, 255, 0.4) 12.93%, rgba(220, 233, 255, 0.4) 88.17%)',
        'linear-gradient(134.06deg, rgba(255, 234, 219, 0.4) -8.19%, rgba(255, 242, 216, 0.4) 100%)',
        'linear-gradient(129.08deg, rgba(234, 238, 246, 0.7) 8.42%, rgba(237, 242, 249, 0.5) 100%)'
    ],
    [
        '#FFFFFF',
        '#FBFCFF',
        '#F6FAFF',
        '#FFFCF6',
        '#fff'
    ]
];

const outFontList = [{
    color: '#1E1F24',
    fontSize: '16px',
    fontWeight: '500'
}, {
    color: '#071B40',
    fontSize: '14px'
}, {
    color: '#071B40',
    fontSize: '14px'
}, {
    color: '#79390A',
    fontSize: '14px'
}, {
    color: '#1E1F24',
    fontSize: '14px',
    fontWeight: '500',
    isSelect: true
}];

// 非会员
const noVipList = [
    [{
        value: '权益名称'
    }, {
        value: '启航会员'
    }, {
        value: '精英会员'
    }, {
        value: '尊享会员'
    }, {
        value: '体验会员'
    }, {
        value: '入驻律师'
    }],
    [{
        value: '百度搜索首位名片卡'
    }, {
        value: '启航会员专属样式，一年期有效'
    }, {
        value: '精英会员专属样式，一年期有效'
    }, {
        value: '尊享会员专属样式，一年期有效'
    }, {
        value: '体验期内展示'
    }, {
        value: ''
    }],
    [{
        value: '百度搜索首位推荐卡'
    }, {
        value: ''
    }, {
        value: '会员有效期内优先展示'
    }, {
        value: '会员有效期内优先展示'
    }, {
        value: '体验期内展示'
    }, {
        value: ''
    }],
    [{
        value: '严选律师标签'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: '按不同会员身份附标签图'
    }, {
        value: ''
    }],
    [{
        value: '擅长领域标签'
    }, {
        value: '3个/一年期有效，不可加购更多领域标签' // 启航会员
    }, {
        value: '3个/一年期有效，会员可加购更多专属领域标签' // 精英会员
    }, {
        value: '3个/一年期有效，会员可加购更多专属领域标签' // 尊享会员
    }, {
        value: '3个/体验结束后自动取消1个标签' // 尊享会员
    }, {
        value: '2个' // 非会员
    }],
    [{
        value: '付费电话咨询'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: ''
    }, {
        value: ''
    }],
    [{
        value: '百度律临全站推荐'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '体验期内曝光'
    }, {
        value: ''
    }],
    // [{
    //     value: '免费在线咨询'
    // }, {
    //     value: '1小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '3小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '6小时内咨询锁定独享，超时解锁进入即时线索抢单'
    // }, {
    //     value: '体验期内曝光'
    // }, {
    //     value: ''
    // }],
    [{
        value: '即时线索抢单'
    }, {
        value: ''
    }, {
        value: '36条/年，按月领取'
    }, {
        value: '60条/年，按月领取'
    }, {
        value: '5条/体验期内可用'
    }, {
        value: ''
    }],
    [{
        value: '公开咨询抢答'
    }, {
        value: '会员有效期内无限畅领，可见线索限量20%'
    }, {
        value: '会员有效期内无限畅领，可见线索限量50%'
    }, {
        value: '会员有效期内无限畅领，可见线索限量70%'
    }, {
        value: '日均5次/体验期内可用'
    }, {
        value: ''
    }],
    [{
        value: '法律文章免费认领'
    }, {
        value: ''
    }, {
        value: '80条/按年领取'
    }, {
        value: '120条/按年领取'
    }, {
        value: '120条/体验期内可用，体验结束后内容自动改为默认律师'
    }, {
        value: ''
    }],
    [{
        value: '问答内容页律师推荐卡'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '体验期内展示'
    }, {
        value: ''
    }],
    [{
        value: '法规检索工具'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }],
    [{
        value: '案例检索工具'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }],
    [{
        value: 'AI合同助手'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }],
    [{
        value: 'AI诉保助手'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }, {
        value: '一年期有效'
    }]
];

const noColorList = [
    [
        '#F8FBFF',
        'linear-gradient(138.21deg, rgba(224, 240, 255, 0.4) 12.93%, rgba(220, 233, 255, 0.4) 88.17%)',
        'linear-gradient(138.21deg, rgba(224, 226, 255, 0.4) 12.93%, rgba(220, 233, 255, 0.4) 88.17%)',
        'linear-gradient(134.06deg, rgba(255, 234, 219, 0.4) -8.19%, rgba(255, 242, 216, 0.4) 100%)',
        'linear-gradient(134.06deg, rgba(255, 234, 219, 0.4) -8.19%, rgba(255, 242, 216, 0.4) 100%)',
        'linear-gradient(129.08deg, rgba(234, 238, 246, 0.7) 8.42%, rgba(237, 242, 249, 0.5) 100%)'
    ],
    [
        '#FFFFFF',
        '#FBFCFF',
        '#F6FAFF',
        '#FFFCF6',
        '#FFFCF6',
        '#fff'
    ]
];

const noFontList = [{
    color: '#1E1F24',
    fontSize: '16px',
    fontWeight: '500'
}, {
    color: '#071B40',
    fontSize: '14px'
}, {
    color: '#071B40',
    fontSize: '14px'
}, {
    color: '#79390A',
    fontSize: '14px'
}, {
    color: '#79390A',
    fontSize: '14px'
}, {
    color: '#1E1F24',
    fontSize: '14px',
    fontWeight: '500',
    isSelect: true
}];

export default {
    beginnerVipList,
    beginnerColorList,
    beginnerFontList,
    eliteVipList,
    eliteColorList,
    eliteFontList,
    vipList,
    vipColorList,
    vipFontList,
    freeVipList,
    freeColorList,
    freeFontList,
    outVipList,
    outColorList,
    outFontList,
    noVipList,
    noColorList,
    noFontList
};